import { loadStripe } from '@stripe/stripe-js';
import { API, STRIPE_KEY } from './constant';

// Strapi decides whether the site runs on Stripe test or live keys (Stripe
// Settings in the admin), so ask it which publishable key to load. Shared
// across the app so Stripe.js is only initialised once.
export const stripePromise = fetch(`${API}/stripe/config`)
    .then((res) => (res.ok ? res.json() : {}))
    .catch(() => ({}))
    .then((config) => loadStripe(config.publishableKey || STRIPE_KEY));
